"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _Menu = _interopRequireDefault(require("@mui/icons-material/Menu"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _ExpandLess = _interopRequireDefault(require("@mui/icons-material/ExpandLess"));
var _SideMenu = _interopRequireDefault(require("./SideMenu"));
var _util = require("./util");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
/* --- Custom App Bar --- */
function Header(_a) {
  var _b = _a.buttonType,
    buttonType = _b === void 0 ? 'hamburger' : _b,
    location = _a.location,
    logo = _a.logo,
    logoDescription = _a.logoDescription,
    links = _a.links,
    backgroundColor = _a.backgroundColor,
    textColor = _a.textColor,
    _c = _a.accentColor,
    accentColor = _c === void 0 ? null : _c,
    _d = _a.drawer,
    drawer = _d === void 0 ? false : _d,
    _e = _a.onLogout,
    onLogout = _e === void 0 ? null : _e,
    _f = _a.title,
    title = _f === void 0 ? '' : _f,
    _g = _a.isLoading,
    isLoading = _g === void 0 ? false : _g,
    _h = _a.onOpen,
    onOpen = _h === void 0 ? function () {
      return undefined;
    } : _h,
    _j = _a.hideMenu,
    hideMenu = _j === void 0 ? false : _j,
    _k = _a.pathname,
    pathname = _k === void 0 ? '' : _k;
  var _l = (0, _react.useState)(null),
    linkMenuanchorEl = _l[0],
    setLinkMenuAnchorEl = _l[1];
  var _m = (0, _react.useState)(null),
    selectedLink = _m[0],
    setSelectedLink = _m[1];
  var _o = (0, _react.useState)(false),
    isSidePanelOpen = _o[0],
    setSidePanelOpen = _o[1];
  var handleLinkMenuClick = function handleLinkMenuClick(event, link) {
    setLinkMenuAnchorEl(event.currentTarget);
    setSelectedLink(link);
  };
  var handleLinkMenuClose = function handleLinkMenuClose() {
    setLinkMenuAnchorEl(null);
    setSelectedLink(null);
  };
  var toggleSideMenu = function toggleSideMenu() {
    if (!isSidePanelOpen) onOpen();
    setSidePanelOpen(!isSidePanelOpen);
  };
  var closeSideMenu = function closeSideMenu() {
    setSidePanelOpen(false);
  };
  var logoutUser = function logoutUser() {
    closeSideMenu();
    onLogout === null || onLogout === void 0 ? void 0 : onLogout();
  };
  return (0, _jsxRuntime.jsx)(_material.AppBar, __assign({
    style: {
      backgroundColor: backgroundColor
    },
    position: "static"
  }, {
    children: (0, _jsxRuntime.jsxs)(_material.Toolbar, {
      children: [(0, _jsxRuntime.jsxs)("div", __assign({
        style: {
          flex: 1,
          display: 'flex',
          alignItems: 'center'
        }
      }, {
        children: [(0, _jsxRuntime.jsx)(_reactRouterDom.Link, __assign({
          to: hideMenu ? '#' : '/'
        }, {
          children: (0, _jsxRuntime.jsx)("img", {
            width: 150,
            height: 50,
            src: logo,
            alt: logoDescription,
            title: logoDescription,
            style: {
              objectFit: 'contain',
              cursor: 'pointer'
            }
          })
        })), title != null && (0, _jsxRuntime.jsx)(_material.Typography, __assign({
          variant: 'h1',
          color: textColor,
          style: {
            marginLeft: 15,
            fontSize: 23,
            textTransform: 'uppercase'
          }
        }, {
          children: title
        }))]
      })), !hideMenu && (isLoading ? (0, _jsxRuntime.jsx)(_material.CircularProgress, {
        size: 20,
        style: {
          color: 'white'
        }
      }) : (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [(0, _jsxRuntime.jsx)(_material.Hidden, __assign({
          mdUp: true,
          implementation: "css"
        }, {
          children: (0, _jsxRuntime.jsxs)("div", __assign({
            style: {
              flex: 1,
              textAlign: 'right'
            }
          }, {
            children: [buttonType === 'hamburger' && (0, _jsxRuntime.jsx)(_material.IconButton, __assign({
              "aria-controls": "nav-menu",
              "aria-haspopup": "true",
              onClick: toggleSideMenu
            }, {
              children: (0, _jsxRuntime.jsx)(_Menu.default, {
                style: {
                  color: textColor
                }
              })
            })), buttonType === 'menu' && (0, _jsxRuntime.jsxs)(_material.Button, __assign({
              "aria-controls": "nav-menu",
              "aria-haspopup": "true",
              onClick: toggleSideMenu,
              variant: "text",
              style: {
                color: textColor,
                fontSize: '14px',
                textTransform: 'none'
              }
            }, {
              children: ["MENU", (0, _jsxRuntime.jsx)(_Menu.default, {
                style: {
                  color: textColor,
                  fontSize: '20px',
                  marginLeft: '2px'
                }
              })]
            }))]
          }))
        })), (0, _jsxRuntime.jsx)(_material.Drawer, __assign({
          anchor: 'right',
          open: isSidePanelOpen,
          onClose: toggleSideMenu
        }, {
          children: (0, _jsxRuntime.jsx)(_SideMenu.default, {
            pathname: pathname,
            toggle: toggleSideMenu,
            links: links,
            logo: logo,
            logoDescription: logoDescription,
            backgroundColor: backgroundColor,
            textColor: textColor,
            accentColor: accentColor,
            logoutUser: onLogout == null ? null : logoutUser
          })
        })), (0, _jsxRuntime.jsx)(_material.Hidden, __assign({
          mdDown: true,
          implementation: "css"
        }, {
          children: drawer ? (0, _jsxRuntime.jsxs)("div", __assign({
            style: {
              flex: 1,
              textAlign: 'right'
            }
          }, {
            children: [buttonType === 'hamburger' && (0, _jsxRuntime.jsx)(_material.IconButton, __assign({
              "aria-controls": "nav-menu",
              "aria-haspopup": "true",
              onClick: toggleSideMenu
            }, {
              children: (0, _jsxRuntime.jsx)(_Menu.default, {
                style: {
                  color: textColor
                }
              })
            })), buttonType === 'menu' && (0, _jsxRuntime.jsxs)(_material.Button, __assign({
              "aria-controls": "nav-menu",
              "aria-haspopup": "true",
              onClick: toggleSideMenu,
              variant: "text",
              style: {
                color: textColor,
                fontSize: '14px',
                textTransform: 'none'
              }
            }, {
              children: ["MENU", (0, _jsxRuntime.jsx)(_Menu.default, {
                style: {
                  color: textColor,
                  fontSize: '20px',
                  marginLeft: '2px'
                }
              })]
            }))]
          })) : (0, _jsxRuntime.jsxs)("div", __assign({
            style: {
              flex: 3,
              display: 'flex',
              justifyContent: 'flex-end'
            }
          }, {
            children: [links.map(function (link, index) {
              var _a;
              return (0, _jsxRuntime.jsxs)("div", {
                children: [(0, _jsxRuntime.jsxs)(_material.Button, __assign({
                  variant: "text",
                  component: _reactRouterDom.Link,
                  style: {
                    marginLeft: '10px',
                    textAlign: 'center',
                    fontSize: '14px',
                    color: !accentColor || (0, _util.isSelected)(pathname, link.slug) ? textColor : accentColor,
                    textDecoration: !accentColor && (0, _util.isSelected)(pathname, link.slug) ? 'underline' : undefined,
                    textUnderlineOffset: '3px'
                  },
                  to: link.subLinks ? '#' : link.slug,
                  "aria-haspopup": link.subLinks ? 'true' : 'false',
                  onClick: link.subLinks ? function (e) {
                    return handleLinkMenuClick(e, link);
                  } : undefined
                }, {
                  children: [link.text, link.subLinks && (linkMenuanchorEl && (selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.slug) === link.slug ? (0, _jsxRuntime.jsx)(_ExpandLess.default, {}) : (0, _jsxRuntime.jsx)(_ExpandMore.default, {}))]
                })), (selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.subLinks) && (0, _jsxRuntime.jsx)(_material.Menu, __assign({
                  id: "simple-menu",
                  anchorEl: linkMenuanchorEl,
                  keepMounted: true,
                  open: Boolean(linkMenuanchorEl),
                  onClose: handleLinkMenuClose,
                  elevation: 0,
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                  }
                }, {
                  children: (_a = selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.subLinks) === null || _a === void 0 ? void 0 : _a.map(
                  // See https://mui.com/material-ui/guides/typescript/#complications-with-the-component-prop
                  function (subLink, subLinkIndex) {
                    return (0, _jsxRuntime.jsx)(_material.MenuItem, __assign({
                      onClick: handleLinkMenuClose,
                      component: _reactRouterDom.Link,
                      to: (selectedLink === null || selectedLink === void 0 ? void 0 : selectedLink.slug) + subLink.slug,
                      style: {
                        fontSize: '14px'
                      }
                    }, {
                      children: subLink.text
                    }), subLinkIndex);
                  })
                }))]
              }, index);
            }), onLogout != null && (0, _jsxRuntime.jsx)(_material.Button, __assign({
              variant: "text",
              style: {
                marginLeft: '10px',
                textAlign: 'center',
                fontSize: '14px',
                color: textColor
              },
              onClick: logoutUser
            }, {
              children: "Logout"
            }))]
          }))
        }))]
      }))]
    })
  }));
}
var _default = Header;
exports.default = _default;